import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

import IconButton from 'src/components/ui/IconButton';
import IconClibboard from 'src/components/ui/Icons/set/IconClibboard';

import { CopyToClipboard } from 'react-copy-to-clipboard';

const iconButtonSX = {
	width: '20px',
	height: '20px',

	'&:not(:hover)': { opacity: 0.5 },
};

const ButtonClipboard = ({ value, valueHint = 'Copy value' }) => (
	<CopyToClipboard text={value}>
		<Tooltip title={valueHint} placement="right">
			<Box>
				<IconButton color="primary" size="small" sx={iconButtonSX}>
					<IconClibboard />
				</IconButton>
			</Box>
		</Tooltip>
	</CopyToClipboard>
);

ButtonClipboard.propTypes = {
	value: PropTypes.string,
	valueHint: PropTypes.string,
	style: PropTypes.any,
};

export default ButtonClipboard;
